import {loader} from '@monaco-editor/react';

// Serve gli asset di Monaco dalla stessa origin (public/vs, copiato da scripts/copy-monaco-editor.js)
// invece che da cdn.jsdelivr.net, irraggiungibile dalla rete di produzione.
loader.config({paths: {vs: `${process.env.PUBLIC_URL}/vs`}});
